module.exports = __webpack_public_path__ + "img/46.5.COD.bcdbc5dc.png";